<template>
  <div class="home">
    <!--     <header class="home-header">  
      <p class="home-subtitle">丽水市汽车运输集团股份有限公司</p>  
    </header>  -->
    <div class="home-actions">
      <button class="home-button" @click="goToQuery">扫码查重</button>
      <button class="home-button" @click="goToQueryByHand">手工查重</button>
      <button class="home-button" @click="goToExport">报销记录</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    goToQuery() {
      try {
        //跳转
        this.$router.push("/scanner");
      } catch (error) {
        console.log("跳转Scanner", error);
      }
    },
    goToQueryByHand() {
      try {
        //跳转
        this.$router.push("/query");
      } catch (error) {
        console.log("跳转Query", error);
      }
    },
    goToExport() {
      try {
        //跳转
        this.$router.push("/export");
      } catch (error) {
        console.log("跳转export", error);
      }
    },
  },
};
</script>

<style scoped>
.home {
  /* 设置一个固定的最大宽度 */
  max-width: 512px; /* 根据你的需求调整这个值 */
  /* 使用margin: auto来水平居中 */
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #ddd;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh; /* 使用视口高度作为容器高度 */
  padding: 20px;
  box-sizing: border-box; /* 确保padding不会增加容器宽度 */
  background-color: #f5f5f5; /* 可选的背景色 */
}

.home-header {
  text-align: center;
}

.home-subtitle {
  font-size: 1rem; /* 根据需要调整字体大小 */
  color: #666;
  margin-top: 0.5rem; /* 增加顶部间距 */
}

.home-actions {
  transform: translateY(18vh); /* 将组件向上移动视口高度的18% */  
  display: flex;
  flex-direction: column; /* 垂直堆叠按钮以适应小屏幕 */
  align-items: center;
  justify-content: center;
  margin-top: 2rem; /* 增加与标题的间距 */
  width: 90%;
}

.home-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* 按钮宽度100%以适应小屏幕 */
  padding: 1rem; /* 增大内边距以适应触摸 */
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  font-size: 1rem; /* 根据需要调整字体大小 */
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 1rem; /* 按钮之间的间距 */
}

.home-button:hover,
.home-button:active {
  background-color: #0056b3; /* 移动设备上通常不使用hover效果，但可以保留active效果 */
}

/* 可选的媒体查询，用于进一步的响应式设计 */
@media (min-width: 600px) {
  .home-actions {
    flex-direction: row; /* 在屏幕宽度足够时水平显示按钮 */
  }

  .home-button {
    width: auto; /* 在屏幕宽度足够时按钮宽度自适应内容 */
    margin-bottom: 0; /* 移除按钮之间的垂直间距 */
    margin-right: 1rem; /* 添加按钮之间的水平间距 */
  }

  .home-button:last-child {
    margin-right: 0; /* 移除最后一个按钮的右边距 */
  }
}
</style>
